import Vue from 'vue';
import Vuelidate from 'vuelidate';

Vue.use(Vuelidate);


//////////////////
// WEBPACK FOOTER
// ./src/plugins/vuelidate.js
// module id = ./src/plugins/vuelidate.js
// module chunks = 34